import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';
import translate from '../translate';

function QRCodeComponent(props) {
  const {
    t,
    value,
    title,
    hasButton,
    onClick,
    buttonText,
    qrClass,
    iconClass,
    classContainer,
    classTitle,
    size,
    btnClass,
    btnDownloadClass,
    hasDownload,
    downloadImageName,
  } = props;
  const downloadQR = () => {
    // Get the element inside, of the container
    const svgElement = document.getElementById('qrCode-container').querySelector('svg');

    // Create a canvas element and set its dimensions to match the SVG
    const canvas = document.createElement('canvas');
    canvas.width = svgElement.clientWidth;
    canvas.height = svgElement.clientHeight;

    // Draw the SVG onto the canvas
    const svgString = new XMLSerializer().serializeToString(svgElement);
    const img = new Image();
    img.onload = () => {
      canvas.getContext('2d').drawImage(img, 0, 0);

      // Convert the canvas to a data URL in PNG format
      const pngUrl = canvas.toDataURL('image/png');

      // Create a link element, set its href attribute to the PNG URL, and trigger a click event on it
      const link = document.createElement('a');
      link.href = pngUrl;
      link.download = downloadImageName || 'qrCode_image.png';
      link.dispatchEvent(new MouseEvent('click'));

      // Clean up the canvas and URL objects
      canvas.remove();
      URL.revokeObjectURL(pngUrl);
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgString)}`;
  };

  return (
    <div className={classContainer}>
      {title && (
        <div className={classTitle}>
          {title}
        </div>
      )}
      <div id="qrCode-container" className={qrClass}>
        <QRCode value={value} size={size} />
      </div>
      <div className={hasDownload ? 'qr-buttons-container' : ''}>
        {hasDownload && (
          <button type="button" className={`btn m-btn--pill btn-info ${btnDownloadClass}`} onClick={downloadQR}>
            <i className="fa fa-download" />
            <span>{t('download.qrcode')}</span>
          </button>
        )}
        {hasButton && (
          <button type="button" className={`btn m-btn--pill btn-dynamic ${btnClass}`} onClick={onClick}>
            <i className={iconClass} />
            <span>{buttonText}</span>
          </button>
        )}
      </div>
    </div>
  );
}

QRCodeComponent.propTypes = {
  t: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  hasButton: PropTypes.bool,
  onClick: PropTypes.func,
  qrClass: PropTypes.string,
  iconClass: PropTypes.string,
  classContainer: PropTypes.string,
  classTitle: PropTypes.string,
  size: PropTypes.number,
  btnClass: PropTypes.string,
  btnDownloadClass: PropTypes.string,
  hasDownload: PropTypes.bool, // shows the qrCode download btn
  downloadImageName: PropTypes.string, // text off the qr code image
};

QRCodeComponent.defaultProps = {
  title: null,
  hasButton: false,
  onClick: () => {},
  buttonText: null,
  qrClass: 'qr-session',
  iconClass: 'fa fa-expand-arrows-alt',
  classContainer: 'qrCode-container',
  classTitle: 'qrCode-title',
  btnClass: 'qrCode-btn',
  btnDownloadClass: 'download-qrCode',
  size: 172,
  hasDownload: false,
  downloadImageName: null,
};

export default translate(QRCodeComponent);
